import {FC, useEffect} from 'react';

import {GemInitialize} from 'app/utils/initialize/components/gemInitialize';
import {defineRemotesLoader} from 'app/utils/initialize/defineRemotesLoader';
import {defineWebComponents} from 'app/utils/initialize/defineWebComponents';
import {GemInitializeWithWebComponentsProps} from 'app/utils/initialize/interface';

export const GemInitializeWithWebComponents: FC<GemInitializeWithWebComponentsProps> = ({gemSettings, context, lazyLoadPage = false}) => {
    useEffect(() => {
        defineWebComponents(gemSettings, lazyLoadPage);
        defineRemotesLoader(gemSettings);
    }, [gemSettings, lazyLoadPage]);

    return <GemInitialize gemSettings={gemSettings} context={context} />;
};
